// import '../scss/main.scss'

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

import barba from '@barba/core';
import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'
import { animationEnter, animationLeave } from './animations';

const App = new function () {

	this.init = () => {
		// Initial setup
		setWin()
		setVh()
		setVw()

		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)
	
		// Barba enter
		barba.hooks.enter((data) => {
			window.scrollTo(0, 0);

			let $newPageHead = $('<head />').html(
				$.parseHTML(
				  data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], // <- use data argument
				  document,
				  true
				)
			);
		})
		barba.hooks.beforeLeave(() => {
			anims.forEach(anim => {
				anim.scrollTrigger.kill();
				anim.pause(0).kill();
			});
		})
		barba.hooks.after(() => {
			initScrolling();
		})

		// Inview
		const anims = [];
		function initScrolling() {
			gsap.utils.toArray("[data-inview]").forEach(function (elem) {
				return (
					anims.push(gsap.to(elem, {
						scrollTrigger: {
							// markers:true,
							scroller: document.querySelector('#ss-page'),
							trigger: elem,
							start: "top 95%",
							end: "bottom 70%",
							onEnter() {
								elem.classList.add('is-inview');
							},
						}
					}))
				)
			});
		}
		initScrolling();


		// Barba Init
		barba.init({
			transitions: [
				{
					name: 'general-transition',
					once({next}) {
						gsap.from('.ss-spinner', {
							duration: .5,
							delay: .3,
							opacity: 1,
							ease: 'power1.out',
							// onComplete: () => animationEnter(next.container)
						});
					},
					leave: ({current}) => animationLeave(current.container),
					enter({next}) {
						window.scrollTo(0, 0);
						animationEnter(next.container)
					},
					beforeEnter: ({ next }) => {
						const matches = next.html.match(/<body.+?class="([^""]*)"/i);
						document.body.setAttribute('class', (matches && matches.at(1)) ?? '');
						
					}
				}, 
			],
		});
  	}

	this.onResize = () => {
		setWin()
		setVh()
		setVw()
	}

}

window.addEventListener('load', App.init)